export const MACRO_EDIT_EVENTS = {
  OPEN_LINK_PICKER: "open-link-picker",
  OPEN_IMAGE_PICKER: "open-image-picker",
  OPEN_ICON_PICKER: "open-icon-picker",
};
